import { useEffect, useState } from 'react';
import { DocumentImage } from '../pages/DoctorsVerification/style';

const extractFileExtension = (fileName: string) => {
  return fileName?.split('.').pop()?.toLowerCase();
};

const ViewDocument = ({ fileName, content }: { fileName: string; content: string }) => {
  const extension = extractFileExtension(fileName) || '';

  const isPdf = extension === 'pdf';
  const isImage = [
    'jpeg',
    'jpg',
    'png',
    'gif',
    'bmp',
    'webp',
    'tiff',
    'ico',
    'heic',
    'svg',
    'eps'
  ].includes(extension);

  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!content) return;

    try {
      // Check if content is a URL
      if (content.startsWith('http') || content.startsWith('blob:')) {
        // Make sure the URL is correctly formatted and encoded
        const validUrl = decodeURIComponent(content);
        setObjectUrl(validUrl);
        return;
      }

      let base64String = content;

      // If content is a Data URL (e.g., "data:image/png;base64,....")
      if (content.startsWith('data:')) {
        const parts = content.split(',');
        if (parts.length > 1) {
          base64String = parts[1];
        } else {
          console.error('Invalid data URL format');
          return;
        }
      }

      // Decode base64 string and create a Blob for the file
      const byteCharacters = atob(base64String);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([byteNumbers], {
        type: isPdf ? 'application/pdf' : `image/${extension}`
      });

      const url = URL.createObjectURL(blob);
      setObjectUrl(url);

      return () => {
        URL.revokeObjectURL(url); // Cleanup the URL object
      };
    } catch (error) {
      console.error('Error decoding base64 content:', error);
      setObjectUrl(content); // Fallback if error occurs
    }
  }, [content, extension]);

  if (isPdf && objectUrl) {
    return (
      <iframe
        src={objectUrl}
        title={fileName || 'Document PDF'}
        className="document-pdf"
        style={{
          paddingTop: '0.5rem',
          width: '100%',
          height: '500px',
          border: 'none',
          overflowX: 'hidden',
          overflowY: 'hidden'
        }}
      />
    );
  } else if (isImage && objectUrl) {
    return (
      <DocumentImage
        src={objectUrl}
        alt={fileName || 'Document'}
        style={{
          maxWidth: '100%',
          height: 'auto'
        }}
      />
    );
  } else {
    // If content is neither PDF nor an image
    return <p></p>;
  }
};

export { ViewDocument };
